import { useState, useEffect, useRef } from 'react';
export const useDebounce = (value, milliSeconds, onDebounce) => {
    const [debouncedValue, setDebouncedValue] = useState(value);
    const onDebounceRef = useRef(onDebounce);
    useEffect(() => {
        onDebounceRef.current = onDebounce;
    }, [onDebounce]);
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
            onDebounceRef.current?.(value);
        }, milliSeconds);
        return () => {
            clearTimeout(handler);
        };
    }, [value, milliSeconds]);
    return debouncedValue;
};
export default useDebounce;
//# sourceMappingURL=useDebounce.js.map